import React from 'react';
import * as shapes from '../../shapes';

const ProductSaleChargeButton = ({ charge, disabled }) => (
  <button
    type="button"
    className="c-btn"
    onClick={charge}
    disabled={disabled}
  >
    Confirm
  </button>
);

ProductSaleChargeButton.propTypes = {
  charge: shapes.handler.isRequired,
  disabled: shapes.flag.isRequired,
};

export default ProductSaleChargeButton;
